/* Liste de variantes réduite (bloc Variant picker > « Réduire la liste des variantes »).
   Pour chaque tableau de variantes visible (.variant-table : tableau simple, à 2 ou à 3 niveaux) :
   - calcule combien de lignes tiennent dans la hauteur de l'écran, pour que le sélecteur complet
     (choix de la base + en-tête du tableau + lignes + bouton) tienne sous l'en-tête collant du site ;
   - réduit le tableau à ces lignes, le reste défile dans le bloc (en-tête du tableau collant) ;
   - ajoute sous le tableau un bouton « afficher plus / réduire ».
   Aucune ligne n'est déplacée dans le DOM : product-bohm.js, les lots et l'ajout au panier
   continuent de fonctionner à l'identique. Fonctionne aussi dans la QuickView.
   Ordinateur uniquement (≥ 1001 px) : sur mobile / tablette, le tableau reste entier. */
(function () {
  if (window.__bohmVariantScroll) return;
  window.__bohmVariantScroll = true;

  var ROOT = '.f8pr-variant-selection[data-variant-scroll]';
  var TABLE = '.variant-table';
  var MIN_HIDDEN = 2; // pas de réduction pour ne masquer qu'une seule variante
  var BOTTOM_GAP = 16;

  // Ordinateur uniquement (breakpoint du thème : 1001 px). Sur mobile / tablette la page défile déjà :
  // pas de second défilement dans le bloc, le tableau reste entier et sans bouton.
  var DESKTOP = window.matchMedia('(min-width: 1001px)');

  // Tableaux ouverts par le client : l'état survit au re-rendu du bloc par le thème
  var expanded = {};

  function getRows(table) {
    return table.querySelectorAll(':scope > .variant-table__row');
  }

  function getHead(table) {
    return table.querySelector(':scope > .variant-table__head');
  }

  function tableKey(table) {
    var article = table.closest('article[data-form-id]');
    return [
      article ? article.getAttribute('data-form-id') : '',
      table.getAttribute('data-option1-table') || '',
      table.getAttribute('data-option2-table') || ''
    ].join('|');
  }

  // Hauteur occupée en haut de l'écran par l'en-tête collant du site quand on fait défiler la fiche
  function stickyHeaderHeight(root) {
    if (root.closest('#quickshop')) return 0; // QuickView : panneau plein écran

    var inner = document.getElementById('header-inner');
    var header = inner && inner.closest('.shopify-section-header');
    if (!header || inner.classList.contains('no-sticky')) return 0;

    if (inner.classList.contains('sticky-nav')) {
      var nav = document.getElementById('nav-bar') || document.getElementById('nav');
      return nav ? nav.offsetHeight : 0;
    }
    return header.offsetHeight;
  }

  // Tout ce qui précède le tableau dans le bloc (choix de la base, 2e niveau d'options, libellés…) :
  // le sélecteur complet doit tenir à l'écran, pas seulement le tableau
  function heightAboveTable(root, table) {
    return Math.max(0, table.getBoundingClientRect().top - root.getBoundingClientRect().top);
  }

  function visibleRowCount(root, table, rows, head, toggle) {
    var available = window.innerHeight
      - stickyHeaderHeight(root)
      - heightAboveTable(root, table)
      - (head ? head.offsetHeight : 0)
      - (toggle ? toggle.offsetHeight : 0)
      - BOTTOM_GAP;

    var count = 0;
    var used = 0;
    for (var i = 0; i < rows.length; i++) {
      used += rows[i].offsetHeight;
      if (used > available) break;
      count++;
    }

    var min = parseInt(root.getAttribute('data-variant-scroll-min'), 10) || 5;
    return Math.max(count, min);
  }

  function moreText(root) {
    return root.getAttribute('data-variant-scroll-more') || 'Afficher plus de variantes';
  }

  function lessText(root) {
    return root.getAttribute('data-variant-scroll-less') || 'Réduire la liste';
  }

  // Styles propres à l'icône du bouton, livrés avec le script (theme-bohm.css n'est pas touché).
  // L'icône est celle du thème (police d'icônes, comme la flèche du fil d'Ariane) : sa taille et
  // son alignement restent ceux du thème ; on la place à gauche du texte et on la retourne quand
  // la liste est ouverte. Toute règle de theme-bohm.css en #main-product … reste prioritaire.
  function injectStyles() {
    if (document.getElementById('variant-scroll-styles')) return;
    var style = document.createElement('style');
    style.id = 'variant-scroll-styles';
    style.textContent =
      '.variant-scroll-toggle__btn .variant-scroll-toggle__icon{margin-left:0;margin-right:6px;transition:transform .2s ease}' +
      '.variant-scroll-toggle__btn[aria-expanded="true"] .variant-scroll-toggle__icon{transform:rotate(180deg)}' +
      '@media (prefers-reduced-motion:reduce){.variant-scroll-toggle__btn .variant-scroll-toggle__icon{transition:none}}';
    document.head.appendChild(style);
  }

  function ensureToggle(root, table) {
    var next = table.nextElementSibling;
    if (next && next.classList.contains('variant-scroll-toggle')) return next;

    injectStyles();

    var wrap = document.createElement('p');
    wrap.className = 'variant-scroll-toggle';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'variant-scroll-toggle__btn';
    // Flèche du thème (bas = afficher, retournée vers le haut = réduire)
    var icon = document.createElement('i');
    icon.className = 'icon-chevron-down variant-scroll-toggle__icon';
    icon.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span');
    label.className = 'variant-scroll-toggle__label';
    label.textContent = moreText(root); // texte posé avant la mesure de la hauteur du bouton
    btn.appendChild(icon);
    btn.appendChild(label);
    wrap.appendChild(btn);
    table.insertAdjacentElement('afterend', wrap);
    return wrap;
  }

  function removeToggle(table) {
    var next = table.nextElementSibling;
    if (next && next.classList.contains('variant-scroll-toggle')) next.remove();
  }

  // Fait apparaître la variante sélectionnée dans la zone visible du tableau réduit
  function revealSelected(table) {
    if (!table.classList.contains('vs-collapsed')) return;
    var radio = table.querySelector('.variant-table__row input[type="radio"]:checked');
    var row = radio && radio.closest('.variant-table__row');
    if (!row) return;

    var head = getHead(table);
    var headHeight = head ? head.offsetHeight : 0;
    var top = row.offsetTop - headHeight;
    var bottom = row.offsetTop + row.offsetHeight;

    if (top < table.scrollTop) {
      table.scrollTop = top;
    } else if (bottom > table.scrollTop + table.clientHeight) {
      table.scrollTop = bottom - table.clientHeight;
    }
  }

  // Tableau rendu à son état d'origine (entier, sans défilement ni bouton)
  function reset(table) {
    table.classList.remove('vs-enabled', 'vs-collapsed');
    table.style.maxHeight = '';
    table.scrollTop = 0;
    table.__vsRevealed = false;
    removeToggle(table);
  }

  function apply(root, table) {
    var rows = getRows(table);
    var head = getHead(table);

    table.classList.add('vs-enabled'); // position: relative → offsetTop des lignes relatif au tableau
    var toggle = ensureToggle(root, table);
    var visible = visibleRowCount(root, table, rows, head, toggle);

    if (rows.length - visible < MIN_HIDDEN) {
      reset(table);
      return;
    }

    if (!table.id) table.id = 'variant-table-' + Math.random().toString(36).slice(2, 9);

    var isExpanded = expanded[tableKey(table)] === true;
    var btn = toggle.querySelector('button');
    btn.querySelector('.variant-scroll-toggle__label').textContent = isExpanded ? lessText(root) : moreText(root);
    btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    btn.setAttribute('aria-controls', table.id);

    if (isExpanded) {
      table.classList.remove('vs-collapsed');
      table.style.maxHeight = '';
    } else {
      table.classList.add('vs-collapsed');
      // Hauteur = en-tête + lignes visibles (haut de la première ligne masquée)
      table.style.maxHeight = rows[visible].offsetTop + 'px';
    }

    if (!table.__vsRevealed) {
      table.__vsRevealed = true;
      revealSelected(table);
    }
  }

  function setupAll() {
    var isDesktop = DESKTOP.matches;
    Array.prototype.forEach.call(document.querySelectorAll(ROOT), function (root) {
      Array.prototype.forEach.call(root.querySelectorAll(TABLE), function (table) {
        if (!isDesktop) {
          // Mobile / tablette (ou fenêtre réduite sous 1001 px) : rien, ou retour à l'état d'origine
          if (table.classList.contains('vs-enabled')) reset(table);
          return;
        }
        // Tableau masqué (autre option 1 / 2) : traité quand il s'affiche
        if (!table.getClientRects().length) return;
        apply(root, table);
      });
    });
  }

  // Bouton afficher / réduire
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.variant-scroll-toggle__btn');
    if (!btn) return;

    var wrap = btn.parentNode;
    var table = wrap.previousElementSibling;
    var root = table && table.closest(ROOT);
    if (!root || !table.classList.contains('variant-table')) return;

    var key = tableKey(table);
    var collapsing = expanded[key] === true;
    var before = wrap.getBoundingClientRect().top;

    expanded[key] = !collapsing;
    apply(root, table);

    // En réduisant une longue liste, on garde le bouton à la même place à l'écran
    if (collapsing) {
      window.scrollBy(0, wrap.getBoundingClientRect().top - before);
      revealSelected(table);
    }
  });

  // Variante choisie (clic, image du slider, URL) : on la garde visible dans le tableau réduit
  document.addEventListener('change', function (e) {
    var table = e.target.closest && e.target.closest(ROOT + ' ' + TABLE + '.vs-collapsed');
    if (table && e.target.matches('input[type="radio"]')) revealSelected(table);
  });

  // Re-rendu du bloc par le thème, changement d'option 1 / 2 (tableaux affichés / masqués), QuickView
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      setupAll();
    });
  }

  function isRelevant(mutation) {
    var el = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (!el) return false;
    return !!(el.closest(ROOT) || (el.querySelector && el.querySelector(ROOT)));
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (isRelevant(mutations[i])) {
        schedule();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupAll, 150);
  });

  // Passage ordinateur ↔ mobile (rotation de tablette, fenêtre redimensionnée) : bascule immédiate
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', setupAll);
  else if (DESKTOP.addListener) DESKTOP.addListener(setupAll);

  window.addEventListener('load', setupAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setupAll);
  document.addEventListener('shopify:section:load', setupAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }
})();
